import { gql } from '@apollo/client';

export const GET_EMPLOYEE_TIMER_STATS = gql`
  query GetEmployeeTimerStats(
    $startDate: String!,
    $endDate: String!,
    $department: String,
    $userId: String,
    $loginUserId: String
  ) {
    getEmployeeTimerStats(
      startDate: $startDate,
      endDate: $endDate,
      department: $department,
      userId: $userId,
      loginUserId: $loginUserId
    ) {
      employees {
        userId
        employeeName
        department
        totalActiveSeconds
        totalActiveHours
        totalSessions
        uniqueRequests
        autoDetectionRate
        taskBreakdown {
          taskType
          totalSeconds
          totalHours
          sessionCount
        }
        sourceBreakdown {
          source
          totalSeconds
          totalHours
          sessionCount
        }
      }
      totalCount
    }
  }
`;
